export default __webpack_public_path__ + "static/media/bmm-slider-4.24ef87f7.jpg";